/* ============================================================
   FOMO TOAST — fomo-toast.js

   TIMING:
   - Toast visible : 3–5 seconds (random)
   - Gap after exit: 8–12 seconds (random)
   - First toast   : 4 seconds after page load

   SHUFFLE:
   - All 25 nudges shuffled into random order on first load
   - No nudge repeats until ALL 25 have been shown
   - After full cycle → reshuffle into new random order → repeat
   ============================================================ */

(function () {
  "use strict";

  const rand = (a, b) => Math.floor(Math.random() * (b - a + 1)) + a;

  /* ── Fisher-Yates shuffle ────────────────────────────── */
  function shuffle(arr) {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  /* ================================================================
     ALL 25 NUDGES
  ================================================================ */
  const ALL_NUDGES = [

    /* ADDED TO CART — 6 */
    {
      type:  "cart",
      title: "Ayush from Delhi just added OREN Mate to cart · the \"i'll do it later\" era is ending",
      badge: { label: "added to cart", cls: "badge-cart" }
    },
    {
      type:  "cart",
      title: "Priya from Mumbai added OREN Mate · one for her, one for her mom",
      badge: { label: "added to cart", cls: "badge-cart" }
    },
    {
      type:  "cart",
      title: "Kabir from Bangalore just added to cart · said he's tired of being tired",
      badge: { label: "added to cart", cls: "badge-cart" }
    },
    {
      type:  "cart",
      title: "Zara from Hyderabad added OREN Mate · her apple watch wasn't giving answers",
      badge: { label: "added to cart", cls: "badge-cart" }
    },
    {
      type:  "cart",
      title: "Rohan from Pune just added to cart · his recovery score is about to hit different",
      badge: { label: "added to cart", cls: "badge-cart" }
    },
    {
      type:  "cart",
      title: "Sneha from Gurgaon added OREN Mate · for her dad who says he's \"absolutely fine\"",
      badge: { label: "added to cart", cls: "badge-cart" }
    },

    /* JUST ORDERED — 6 */
    {
      type:  "order",
      title: "Aryan from Bangalore just ordered · no screen, no buzz, just answers",
      badge: { label: "just ordered", cls: "badge-order" }
    },
    {
      type:  "order",
      title: "Rhea from Delhi ordered OREN Mate · she'll know her sleep score before you do",
      badge: { label: "just ordered", cls: "badge-order" }
    },
    {
      type:  "order",
      title: "Vedant from Mumbai just ordered · his 3am wake-ups are about to make sense",
      badge: { label: "just ordered", cls: "badge-order" }
    },
    {
      type:  "order",
      title: "Tara from Chennai ordered · one for her, one for her partner",
      badge: { label: "just ordered", cls: "badge-order" }
    },
    {
      type:  "order",
      title: "Aditya from Noida just placed his order · his body's been talking, he finally listened",
      badge: { label: "just ordered", cls: "badge-order" }
    },
    {
      type:  "order",
      title: "Simran from Chandigarh ordered · her parents don't know yet, but their health's about to be tracked",
      badge: { label: "just ordered", cls: "badge-order" }
    },

    /* PEOPLE WATCHING — 4 */
    {
      type:  "watching",
      title: "11 people on this page rn · 4 already ordered · you're still reading · just saying 👀",
      badge: { label: "watching", cls: "badge-watching" }
    },
    {
      type:  "watching",
      title: "8 buyers from Delhi & Mumbai checking out OREN Mate as you scroll · some already hit checkout",
      badge: { label: "watching", cls: "badge-watching" }
    },
    {
      type:  "watching",
      title: "6 people added OREN Mate to cart in the last hour · your cart's been waiting longer than theirs 👀",
      badge: { label: "watching", cls: "badge-watching" }
    },
    {
      type:  "watching",
      title: "9 people here rn · at least 3 already know their resting heart rate · do you?",
      badge: { label: "watching", cls: "badge-watching" }
    },

    /* TRENDING — 4 */
    {
      type:  "trending",
      title: "most ordered wellness ring in Bangalore this month · OREN Mate · and you're still on the fence 👀",
      badge: { label: "trending", cls: "badge-trending" }
    },
    {
      type:  "trending",
      title: "3 buyers this week ordered a second ring for their parents · that's the connected reassurance effect",
      badge: { label: "trending", cls: "badge-trending" }
    },
    {
      type:  "trending",
      title: "top searched wearable among Mumbai professionals rn · OREN Mate · they know something · just saying",
      badge: { label: "trending", cls: "badge-trending" }
    },
    {
      type:  "trending",
      title: "Ayesha from Delhi came back to this page 4 times · ordered on the 5th",
      badge: { label: "trending", cls: "badge-trending" }
    },

    /* ANCHOR — 5 */
    {
      type:  "anchor",
      title: "Karan from Mumbai waited 3 days · his colleague ordered same day · his colleague's sleeping better already · Karan's still thinking 💀",
      badge: { label: "anchor", cls: "badge-anchor" }
    },
    {
      type:  "anchor",
      title: "your body's been sending signals for months · OREN Mate is just the translator · and it's been waiting in your cart",
      badge: { label: "anchor", cls: "badge-anchor" }
    },
    {
      type:  "anchor",
      title: "Priya from Delhi had it in her cart for 2 days · came back · still available · barely",
      badge: { label: "anchor", cls: "badge-anchor" }
    },
    {
      type:  "anchor",
      title: "Meera from Pune ordered one for her mom · her mom cried · we're not okay 🖤",
      badge: { label: "anchor", cls: "badge-anchor" }
    },
    {
      type:  "anchor",
      title: "the people feeling good every morning didn't get lucky · they just ordered before you did",
      badge: { label: "anchor", cls: "badge-anchor" }
    }

  ]; /* 25 total */

  /* ── Measure ATC bar height ──────────────────────────── */
  function getBottomOffset() {
    const CLEARANCE = 44;
    const selectors = [
      ".sticky-atc", ".sticky-add-to-cart", ".product-sticky-bar",
      ".sticky-bar", ".cart-bar", ".atc-bar", "#sticky-atc",
      ".product-form__sticky", ".js-sticky-atc", "[data-sticky-atc]",
      ".sticky-product-form", ".product__sticky-form",
      ".site-footer-sticky-atc"
    ].join(", ");

    let barH = 0;
    try {
      document.querySelectorAll(selectors).forEach(function (el) {
        const rect  = el.getBoundingClientRect();
        const style = window.getComputedStyle(el);
        const ok = rect.height > 0
          && style.display    !== "none"
          && style.visibility !== "hidden"
          && rect.bottom      >= window.innerHeight - 10;
        if (ok) barH = Math.max(barH, rect.height);
      });
    } catch (e) {}

    if (!barH) barH = window.innerWidth <= 768 ? 80 : 72;
    return barH + CLEARANCE;
  }

  function applyOffset(container) {
    container.style.bottom = getBottomOffset() + "px";
  }

  /* ── Render one toast ────────────────────────────────── */
  function renderToast(container, nudge, onDone) {
    /* Remove previous */
    const old = container.querySelector(".fomo-pop");
    if (old) {
      old.classList.add("fomo-exit");
      setTimeout(() => old.remove(), 260);
    }

    const el = document.createElement("div");
    el.className = `fomo-pop type-${nudge.type}`;
    el.innerHTML = `
      <span class="fomo-dot"></span>
      <div class="fomo-body">
        <div class="fomo-title">
          ${nudge.title}
          <span class="fomo-badge ${nudge.badge.cls}">${nudge.badge.label}</span>
        </div>
      </div>
      <button class="fomo-close" aria-label="Dismiss">&times;</button>
    `;

    let gone = false;

    function dismiss() {
      if (gone) return;
      gone = true;
      el.classList.add("fomo-exit");
      setTimeout(function () {
        el.remove();
        /* ── 8–12 second gap before next toast ── */
        setTimeout(onDone, rand(8000, 12000));
      }, 260);
    }

    el.querySelector(".fomo-close").addEventListener("click", dismiss);
    container.appendChild(el);

    /* ── Visible for 3–5 seconds ── */
    setTimeout(dismiss, rand(3000, 5000));
  }

  /* ── Init ────────────────────────────────────────────── */
  function init() {
    let container = document.getElementById("fomoToast");
    if (!container) return;

    /* Move to <body> — escapes overflow:hidden / transform traps */
    if (container.parentNode !== document.body) {
      document.body.appendChild(container);
    }

    applyOffset(container);
    window.addEventListener("resize", () => applyOffset(container), { passive: true });
    window.addEventListener("load",   () => setTimeout(() => applyOffset(container), 600));

    /* ── Shuffle queue — no repeats until all 25 shown ── */
    let queue = shuffle(ALL_NUDGES); /* shuffled ONCE on load */
    let idx   = 0;

    function showNext() {
      /* Cycle complete — reshuffle and start again */
      if (idx >= queue.length) {
        queue = shuffle(ALL_NUDGES);
        idx   = 0;
      }
      renderToast(container, queue[idx++], showNext);
    }

    /* First toast after 4s */
    setTimeout(showNext, 4000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();